import React from 'react';

import SupplierShow from '@components/shared/suppliers/SupplierShow';
import supplierService from '@services/operator/supplierService';

export default function OperatorSupplierShow() {
  return <SupplierShow service={supplierService} role="operator" />;
}
